import React, {Component} from 'react';
import AmountField from "../lib/mdb/amount-field";
import DateField from "../lib/mdb/date-field";
import {updateTotals, formatAmount} from "../lib/payment-utils";
import {getPtDescriptionByCode} from "../lib/utils";
import {moment} from "../lib/ext-refs";


class PaymentInfo extends Component {

    render() {
        const {config, payment, idx, showIcon, state} = this.props;
        const {PaymentInfoHeader, PaymentInfoBody} = this.props.appComponents;
        return (
            <div className="opp-section" id={`PaymentInfo${idx + 1}`}>
                <PaymentInfoHeader
                    payment={payment}
                    config={config}
                    showIcon={showIcon}
                    />
                <div className="row">
                    <div className="col-12">
                        <div className="card card-v2">
                            <div className="card-body">
                                <div className="payment-info-container">
                                    <PaymentInfoBody
                                        config={config}
                                        payment={payment}
                                        idx={idx}
                                        state={state}
                                        appComponents={this.props.appComponents}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class PaymentInfoHeader extends Component {
    render() {
        const {config, payment, showIcon} = this.props,
            {messages} = config,
        accountNumber = payment.header.accountNumber;
        return (
            <h3 className="section-title">
                {showIcon && (
                    <span className="section-icon">
                            <img src={messages["opp.icon-payment-info"] || "images/icon-payment-items.png"}
                                 alt="Payment Information"/>
                        </span>)
                }
                <span
                    className="section-text">{messages["otp.paymentInfo.title"]} {accountNumber ? `- ${accountNumber}` : ''}</span>
            </h3>
        )
    }
}

class PaymentInfoBody extends Component {
    render() {
        const {config, payment, idx, state, appComponents} = this.props;
        const {ShoppingCart, SinglePay} = appComponents;
        if (payment.bundle) {
            return <ShoppingCart
                config={config}
                payment={payment}
                idx={idx}
                state={state}
                appComponents={appComponents}
            />
        }
        return <SinglePay
            config={config}
            payment={payment}
            idx={idx}
            state={state}
        />
    }
}

class SinglePay extends Component {
    constructor(props) {
        super(props);
        this.onAmountFieldChanged = this.onAmountFieldChanged.bind(this);
    }

    /**
     * This is the post process method for the payment amount input field.
     * Functionality includes:
     * - update total payment amounts in the state
     * @param name
     * @param value
     * @param data
     */
    onAmountFieldChanged(name, value, data) {
        updateTotals(data);
    }

    render() {
        const {config, payment, idx, alwaysShowAmountDue } = this.props;
        const {header} = payment;
        const liability = payment.liability || {};
        const {messages, paymentConfig} = config;
        const {payLaterEnabled} = paymentConfig;
        const now = moment();
        const hasDueDate = !!liability.dueDate;
        const showAmountDue = alwaysShowAmountDue || !!liability.amountDue;
        const dueDateFormat = messages["payment.dueDate.format"] || 'MM/DD/YYYY';
        const hidePaymentType = this.props.hidePaymentType || false;

        return (
            <div className="row">
                <div className="col-12">
                    <h4 className="subsection-title">{messages["payment.cm.single.label"]}</h4>
                    <table
                        className="table table-payment table-hover table-sm-custom table-bordered-simple table-vertical-middle">
                        <thead className="table-payment-thead">
                        <tr>
                            <th className="account-num-col dark-grey-text">{messages["payment.accountNumber.label"]}</th>
                            {!hidePaymentType && (
                                <th className="payment-type-col dark-grey-text text-center">{messages["payment.type.label"]}</th>
                            )}
                            {showAmountDue && (
                                <th className="amount-due-col dark-grey-text text-right">{messages["payment.amountDue.label"]}</th>
                            )}
                            {hasDueDate && (
                                <th className="due-date-col dark-grey-text">{messages["payment.dueDate.label"]}</th>
                            )}
                            <th className="payment-amount-col dark-grey-text text-right">{messages["payment.amount.label"]}</th>
                            {payLaterEnabled && (
                                <th className="payment-date-col dark-grey-text text-left">{messages["payment.date.label"]}</th>
                            )}
                        </tr>
                        </thead>
                        <tbody>
                        <tr data-account={header.accountNumber}>
                            <td className="account-num-col">{header.accountNumber}</td>
                            {!hidePaymentType && (
                                <td className="payment-type-col  text-center">
                                    {getPtDescriptionByCode(config.paymentConfig, header.paymentTypeCode)}
                                </td>
                            )}
                            {showAmountDue && (
                                <td className="amount-due-col dark-grey-text text-right">
                                    {formatAmount(liability.amountDue || 0)}
                                </td>
                            )}
                            {hasDueDate && (
                                <td className="due-date-col dark-grey-text">{
                                    moment(liability.dueDate,"MMDDYYYY").format(dueDateFormat)
                                }</td>
                            )}
                            <td className="payment-amount-col">
                                <AmountField
                                    name={`payments[${idx}].header.paymentAmount`}
                                    postProcess={this.onAmountFieldChanged}
                                    validations={{
                                        required: (value) => (
                                            value > 0
                                                ? ''
                                                : messages["paymentAmount.empty"] || 'Payment amount required'
                                        )
                                    }}
                                />
                            </td>
                            {payLaterEnabled && (
                                <td className="payment-date-col">
                                    <DateField
                                        name={`payments[${idx}].header.effectiveDate.dateStr`}
                                        placeholder="Select Date"
                                        className="md-form form-group m-0"
                                        min={now.unix()}
                                        max={config.paymentConfig.maxPayLaterDays}
                                    />
                                </td>
                            )}
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

class ShoppingCart extends Component {
    render() {
    const {config, payment, idx, state, appComponents} = this.props;
    const {ShoppingCartPaymentWrapper} = appComponents;
        return (
     
                <ShoppingCartPaymentWrapper
                    key={"ShoppingCartPaymentWrapper"}
                    idx={idx}
                    config={config}
                    payment={payment}
                    state={state}
                    appComponents={appComponents}
                />
            
        );
    }
}

export {
    PaymentInfo,
    PaymentInfoHeader,
    PaymentInfoBody,
    ShoppingCart,
    SinglePay
};

